// JivoWidget — подключение виджета онлайн-чата JivoChat только на лендинге (/main).
// V15.1: скрипт code.jivo.ru/widget/dqai7TKE5O добавляется при монтировании и
// удаляется при демонтировании (на внутренних страницах чат не рендерится).
import { useEffect } from 'react';

const JIVO_WIDGET_URL = '//code.jivo.ru/widget/dqai7TKE5O';

export function JivoWidget() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = JIVO_WIDGET_URL;
    script.async = true;
    script.dataset.jivoWidget = 'true';
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);
  return null;
}
